import React from "react";
import { StatusCell } from "@/components/status/cell";
import { DateCell } from "@/components/date/cell";
import { EmployeeCell } from "components/cell/employee/cell";
import { Link } from "react-router-dom";
import { ROUTE } from "@/lib/utils";
import MilestonesFilters from "./filters";
import { List } from "components/index";
import { getEmployeeFields } from "components/user/config";

const ProjectCell = (info) => {
  const project = info.row.original.job?.project;
  if (!project) return null;
  return (
    <Link to={ROUTE.PROJECT(project.project_id)} target="_blank">
      <div className="hover:underline">{project.name}</div>
    </Link>
  );
};

const JobCell = (info) => {
  const job = info.row.original.job;
  if (!job) return null;
  return (
    <Link to={ROUTE.JOB(job.id)} target="_blank">
      <div className="hover:underline">{job.name}</div>
    </Link>
  );
};

const fields = [
  "id",
  "name",
  "status",
  "start_date",
  "end_date",
  "job.id",
  "job.name",
  "job.project.name",
  "job.project.project_id",
  getEmployeeFields("coordinator"),
];

const columns = [
  {
    id: "name",
    header: "Milestone",
    accessorKey: "name",
  },
  {
    id: "status",
    header: "Status",
    accessorKey: "status",
    cell: StatusCell,
  },
  {
    id: "job.project.name",
    header: "Project",
    accessorKey: "job.project.name",
    cell: ProjectCell,
  },
  {
    id: "job.name",
    header: "Job",
    accessorKey: "job.name",
    cell: JobCell,
  },
  {
    id: "coordinator",
    header: "MC",
    accessorKey: "coordinator",
    cell: EmployeeCell,
  },
  {
    id: "start_date",
    header: "Start Date",
    accessorKey: "start_date",
    sortable: true,
    cell: DateCell,
  },
  {
    id: "end_date",
    header: "End Date",
    accessorKey: "end_date",
    sortable: true,
    cell: DateCell,
  },
];

const customSearch = (search) => ({
  _or: [
    { name: { _icontains: search } },
    { job: { name: { _icontains: search } } },
    { job: { project: { name: { _icontains: search } } } },
  ],
});

const defaultFilters = {
  status: { _eq: "in_progress" }
}

export default function Milestones() {
  return (
    <List
      title="Milestones"
      endPoint="milestones"
      storageKey="milestones"
      columns={columns}
      meta={{ fields, customSearch }}
      filters={defaultFilters}
      renderFilters={MilestonesFilters}
      href={(item) => ROUTE.MILESTONE(item.id)}
    />
  );
}
